<template>
	<div class="container-fluid">
		<div class="row mt-3">
			<div class="col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3 col-xxl-3">
				<div class="mb-3">
					<v-select
						v-model="reservation.origin"
						:placeholder="loading_origins ? $t('selects.origin_loading') : $t('selects.origin')"
						:loading="loading_origins"
						:options="origins"
						:disabled="loading_origins"
						:searchable="true"
						:filterable="true"
						:clearable="false"
						data-cy="origin-select"
					>
						<template
							#no-options="{ search, searching, loading }"
						>{{ $t('selects.alert.error.origins_not_found') }}</template>
					</v-select>
				</div>

				<div class="mb-3">
					<v-select
						v-model="reservation.destination"
						:placeholder="loading_origins ? $t('selects.destination_loading') : $t('selects.destination')"
						:options="(reservation.origin === null) ? [] : destinations[reservation.origin.ref]"
						:loading="loading_origins"
						:disabled="loading_origins"
						:searchable="true"
						:filterable="true"
						:clearable="false"
						data-cy="destination-select"
					>
						<template
							#no-options="{ search, searching, loading }"
						>{{ $t('selects.alert.error.destinations_not_found') }}</template>
					</v-select>
				</div>
			</div>
			<div class="col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3 col-xxl-3">
				<div class="row mb-3">
					<div
						class="RegularContainer col"
						ref="passengerSelector"
						v-click-outside="displaySelectorClose"
					>
						<button class="PassengersSelector align-bottom" @click="toggle()">
							<span
								class="align-middle"
								style="padding-top: 5px"
							>{{ total_passengers }} {{ $t('selects.passengers.title') }}</span>
							<mu-icon value="expand_more" :size="30" color="#ced4da"></mu-icon>
						</button>
						<div v-if="display_selector" class="SelectorContainer">
							<ul class="PassengersSelectorContent">
								<li class="PassengersSelectorItem">
									{{ $t('selects.passengers.adult') }}
									<div class="PassengersSelectorOperators">
										<mu-icon class="cursor-icon" @click="quantityPassengers('adult', '-')" value="remove" data-cy="remove-adult"></mu-icon>
										<span data-cy="value-adult">{{ pax.adult }}</span>
										<mu-icon class="cursor-icon" @click="quantityPassengers('adult', '+')" value="add" data-cy="add-adult"></mu-icon>
									</div>
								</li>
								<li class="PassengersSelectorItem">
									{{ $t('selects.passengers.minor') }} {{ $t('selects.passengers.old_1') }}
									<div class="PassengersSelectorOperators">
										<mu-icon class="cursor-icon" @click="quantityPassengers('children', '-')" value="remove" data-cy="remove-children"></mu-icon>
										<span data-cy="value-children">{{ pax.children }}</span>
										<mu-icon class="cursor-icon" @click="quantityPassengers('children', '+')" value="add" data-cy="add-children"></mu-icon>
									</div>
								</li>
								<li class="PassengersSelectorItem">
									{{ $t('selects.passengers.inapam') }}
									<div class="PassengersSelectorOperators">
										<mu-icon class="cursor-icon" @click="quantityPassengers('inapam', '-')" value="remove" data-cy="remove-inapam"></mu-icon>
										<span data-cy="value-inapam">{{ pax.inapam }}</span>
										<mu-icon class="cursor-icon" @click="quantityPassengers('inapam', '+')" value="add" data-cy="add-inapam"></mu-icon>
									</div>
								</li>
								<li class="PassengersSelectorItem">
									{{ $t('selects.passengers.infant') }} {{ $t('selects.passengers.old_0') }}
									<div class="PassengersSelectorOperators">
										<mu-icon class="cursor-icon" @click="quantityPassengers('infant', '-')" value="remove" data-cy="remove-infant"></mu-icon>
										<span data-cy="value-infant">{{ pax.infant }}</span>
										<mu-icon class="cursor-icon" @click="quantityPassengers('infant', '+')" value="add" data-cy="add-infant"></mu-icon>
									</div>
								</li>

								<li class="PassengersSelectorItem" v-if="sep_date.active != undefined && sep_date.active">
									{{ $t('selects.passengers.student') }}
									<div class="PassengersSelectorOperators">
										<mu-icon class="cursor-icon" @click="quantityPassengers('student', '-')" value="remove" data-cy="remove-student"></mu-icon>
										<span data-cy="value-student">{{ pax.student }}</span>
										<mu-icon class="cursor-icon" @click="quantityPassengers('student', '+')" value="add" data-cy="add-student"></mu-icon>
									</div>
								</li>
								<li class="PassengersSelectorItem" v-if="sep_flex_date.active != undefined && sep_flex_date.active">
									{{ $t('selects.passengers.student_flex') }}
									<div class="PassengersSelectorOperators">
										<mu-icon
											class="cursor-icon"
											@click="quantityPassengers('student_flex', '-')"
											value="remove"
											data-cy="remove-student_flex"
										></mu-icon>
										<span data-cy="value-student_flex">{{ pax.student_flex }}</span>
										<mu-icon class="cursor-icon" @click="quantityPassengers('student_flex', '+')" value="add" data-cy="add-student_flex"></mu-icon>
									</div>
								</li>
								<li class="PassengersSelectorItem" v-if="sep_date.active != undefined && sep_date.active">
									{{ $t('selects.passengers.teacher') }}
									<div class="PassengersSelectorOperators">
										<mu-icon class="cursor-icon" @click="quantityPassengers('teacher', '-')" value="remove" data-cy="remove-teacher"></mu-icon>
										<span data-cy="value-teacher">{{ pax.teacher }}</span>
										<mu-icon class="cursor-icon" @click="quantityPassengers('teacher', '+')" value="add" data-cy="add-teacher"></mu-icon>
									</div>
								</li>
								<li class="PassengersSelectorItem" v-if="sep_flex_date.active != undefined && sep_flex_date.active">
                                    {{ $t('selects.passengers.teacher_flex') }}
                                    <div class="PassengersSelectorOperators">
                                        <mu-icon class="cursor-icon" @click="quantityPassengers('teacher_flex', '-')" value="remove" data-cy="remove-teacher_flex"></mu-icon>
                                            <span data-cy="value-teacher_flex">{{ pax.teacher_flex }}</span>
                                        <mu-icon class="cursor-icon" @click="quantityPassengers('teacher_flex', '+')" value="add" data-cy="add-teacher_flex"></mu-icon>
                                    </div>
								</li>

								<li v-if="sep_date.active != undefined && sep_date.active || sep_flex_date.active != undefined && sep_flex_date.active" class="text-center mt-2">
									<div v-if="sep_date.active != undefined && sep_date.active" v-html="$t('input.sep', sep_date)" class="sep-font" />
									<div v-if="sep_flex_date.active != undefined && sep_flex_date.active" v-html="$t('input.sep_flex', sep_flex_date)" class="sep-font" />
									<div v-html="$t('input.sep_note')" class="sep-font" />
									<a href="/servicios/estudiantes-maestros">
										{{ $t('input.content.txt6') }}
									</a>
								</li>
								<li class="text-center my-2">
									<mu-button color="indigo900" data-cy="ok-btn-passengers" @click="toggle()">OK</mu-button>
								</li>
							</ul>
						</div>
					</div>
					<div class="CheckboxContainer" data-cy="reservation-round-checkbox">
						<mu-checkbox
							v-model="reservation.round"
							:label="$t('input.round')"
							@change="checkboxBehavior()"
						></mu-checkbox>
					</div>
				</div>
				<div class="input-group input-group-sm mb-3" v-if="config.promotional_code">
					<input v-model="promotion.code" type="text" class="form-control"
						:placeholder="$t('promotional_code')" aria-label="Recipient's username"
						aria-describedby="basic-addon2" :disabled="promotion.is_valid" data-cy="promotion-code-text" />
					<div class="input-group-append">
						<button @click="applyCode()"
							:class="(promotion.is_valid) ? 'btn btn-success' : 'btn btn-secondary'" type="button"
							data-cy="promotion-code-button">{{ (promotion.is_valid) ? $t('button_action.applied') :
						$t('button_action.apply') }}</button>
					</div>
					<mu-tooltip placement="left" v-if="promotion.is_valid">
						<div slot="content">
							<p class="promotionalInfoTitle">
								{{ $t('promotional_code_info.title', { promotional_code: promotion.code }) }}
							</p>
							<p class="promotionalInfoText" v-if="promotion.promotion_info.validity_type == 'date'">
								{{ $t('promotional_code_info.sale_date', {
									sale_start: $datetime.dateFormater(promotion.promotion_info.sale_start, 'dd mmm, yyyy', lang),
									sale_end: $datetime.dateFormater(promotion.promotion_info.sale_end, 'dd mmm, yyyy', lang),
								}) }}
							</p>
							<p class="promotionalInfoText" v-if="promotion.promotion_info.validity_type == 'date' && promotion.promotion_info.sale_hour_start != '00:00:00' && promotion.promotion_info.sale_hour_end != '23:59:59'">
								{{ $t('promotional_code_info.sale_hour', {
									sale_hour_start: promotion.promotion_info.sale_hour_start.substr(0, 5),
									sale_end: promotion.promotion_info.sale_hour_end.substr(0, 5),
								}) }}
							</p>
							<p class="promotionalInfoText" v-if="promotion.promotion_info.validity_type == 'travel'">
								{{ $t('promotional_code_info.travel_date', {
									sale_start: $datetime.dateFormater(promotion.promotion_info.travel_start, 'dd mmm, yyyy', lang),
									sale_end: $datetime.dateFormater(promotion.promotion_info.travel_end, 'dd mmm, yyyy', lang),
								}) }}
							</p>
							<p class="promotionalInfoText" v-if="promotion.promotion_info.validity_type == 'travel' && promotion.promotion_info.travel_hour_start != '00:00:00' && promotion.promotion_info.travel_hour_end != '23:59:59'">
								{{ $t('promotional_code_info.sale_hour', {
									sale_hour_start: promotion.promotion_info.travel_hour_start.substr(0, 5),
									sale_end: promotion.promotion_info.travel_hour_end.substr(0, 5),
								}) }}
							</p>
							<p class="promotionalInfoText" v-if="promotion.promotion_info.apply_date">
								{{ $t('promotional_code_info.apply_date') }}
							</p>
							<p class="promotionalInfoText" v-if="promotion.promotion_info.apply_open">
								{{ $t('promotional_code_info.apply_open') }}
							</p>
							<p class="promotionalInfoText" v-if="!promotion.promotion_info.apply_date">
								{{ $t('promotional_code_info.not_apply_date') }}
							</p>
							<p class="promotionalInfoText" v-if="!promotion.promotion_info.apply_open">
								{{ $t('promotional_code_info.not_apply_open') }}
							</p>
							<p class="promotionalInfoText">
								{{ $t('promotional_code_info.adult_only') }}
							</p>
						</div>
						<mu-button class="right btnInfopromotionalCode" icon>
							<mu-icon color="#2196f3" size="32" value="info"></mu-icon>
						</mu-button>
					</mu-tooltip>
				</div>
			</div>
			<div class="col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3 col-xxl-3">
				<div class="row RowContainer mb-3">
					<div class="col">
						<datepicker
							data-cy="going-date-picker"
							id="goingDatepicker"
							class="DatePicker"
							:disabled-dates="departure_date_disable"
							:bootstrap-styling="true"
							:input-class="'form-control-lg'"
							:format="'dd/MM/yyyy'"
							:placeholder="(reservation.departure.open) ? $t('selects.open') : $t('selects.date_departure')"
							:disabled="reservation.departure.open"
							@input="selectionDate('departure')"
							v-model="reservation.departure.date"
							:language="lang === 'es' ? es : en"
						>
						</datepicker>
					</div>
					<div class="CheckboxContainer" data-cy="reservation-departure-open-checkbox">
						<mu-checkbox
							v-model="reservation.departure.open"
							:label="$t('selects.open')"
							@change="checkboxBehavior()"
						></mu-checkbox>
					</div>
				</div>
				<div class="row RowContainer mb-3" v-if="reservation.round">
					<div class="col">
						<datepicker
							id="returningDatepicker"
							data-cy="returning-date-datepicker"
							class="DatePicker"
							:disabled-dates="return_date_disable"
							:bootstrap-styling="true"
							:input-class="'form-control-lg'"
							:format="'dd/MM/yyyy'"
							:placeholder="(reservation.return.open) ? $t('selects.open') : $t('selects.date_return')"
							:disabled="reservation.return.open"
							@input="selectionDate('return')"
							v-model="reservation.return.date"
							:language="lang === 'es' ? es : en"
						></datepicker>
					</div>
					<div class="CheckboxContainer" data-cy="reservation-return-open-checkbox">
						<mu-checkbox
							v-model="reservation.return.open"
							:label="$t('selects.open')"
							:disabled="reservation.departure.open"
							@change="checkboxBehavior()"
						></mu-checkbox>
					</div>
				</div>
			</div>
			<div class="col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3 col-xxl-3 text-center">
				<div class="col-12 row">
					<div class="col-10">
						<div class="form-group">
							<mu-button color="lightBlue500" @click="createReserve()" large data-cy="search-button">
								<mu-icon value="search" class="mr-1"></mu-icon>
								{{ $t('button_action.search') }}
							</mu-button>
						</div>
						<div class="row justify-content-center mb-1">
							<div class="center d-flex flex-row">

								<vs-button icon href="tel:+52(33)31118778">
									<i class="bx bxs-phone-call"></i>
								</vs-button>

								<vs-button
									icon
									color="whatsapp"
									href="https://api.whatsapp.com/send?phone=523315266794"
									blank
								>
									<i class="bx bxl-whatsapp"></i>
								</vs-button>

								<vs-button icon color="warn" href="/promotions">
									<i class="bx bxs-purchase-tag"></i>
								</vs-button>
							</div>
						</div>
					</div>
					<div class="col-2">
						<mu-tooltip placement="left">
							<div slot="content">
								<img src="/images/search_reservation/open_ticket.png" width="300" style="border-radius: 15px;">
							</div>
							<mu-button class="mt-2 right" icon>
						 		<mu-icon color="#2196f3" size="32" value="info"></mu-icon>
						 	</mu-button>
						</mu-tooltip>
					</div>
				</div>
			</div>
		</div>

		<div class="row" style="background-color: #000">
			<div class="col-12 p-0">
				<payment-logos />
			</div>
		</div>
	</div>
</template>


<script>

// COMPONENTS
import Datepicker from 'vuejs-datepicker'
import PaymentLogos from '@/components/PaymentLogos/Index'
import { en, es } from 'vuejs-datepicker/dist/locale'
// HELPERS
import _GlobalHelper from '@/store/helpers/global'
import _ReservationHelper from '@/store/helpers/reservation/reservation'
// VUEX
import { mapMutations, mapGetters, mapActions } from 'vuex'

// Export Component
export default {
	name: 'search-form',
	components: {
		Datepicker: Datepicker,
		PaymentLogos: PaymentLogos,
	},
	data() {
		return {
			en: en,
			es: es,
			display_selector: false,
			config: {},
			// Sep
			validity: {
				sep: {},
				flex: {}
			},
			// Origins and Destinations
			origins: [],
			destinations: [],
			form_active: false,
			sep_date: {},
			sep_flex_date: {},
			reservation: {
				code: null,
				origin: null,
				destination: null,
				round: true,
				departure: {
					date: null,
					open: false
				},
				return: {
					date: null,
					open: true
				},
				promotional_code: null,
				configs: null,
				passengers: null,
				summary: null
			},
			pax: {
				adult: 0,
				children: 0,
				inapam: 0,
				infant: 0,
				student: 0,
				student_flex: 0,
				teacher: 0,
				teacher_flex: 0,
			},
			total_passengers: 0,
			default_point: 0,
			promotion: {
				visible: true,
				code: null,
				is_valid: false,
				promotion_info: null
			},
			departure_date_disable: {
				to: new Date(),
				from: null
			},
			return_date_disable: {
				to: new Date()
			},
			startDate: null,
			endDate: null,
			formActive: true,
			loading_origins: true,
			loading_create_reservation: false
		}
	},
	computed: {
		...mapGetters({
			get_language: _GlobalHelper.getters.language,
			show_search_form: _GlobalHelper.getters.show_search_form,
			fechaSep: _GlobalHelper.getters.fecha_sep,
			fecha_finSep: _GlobalHelper.getters.fecha_fin_sep
		}),

		// startDate() {
		//     return `${this.$datetime.dateFormater(this.config.sep.presale_start_date, "dd")} DE ${this.$datetime.getMonth(this.config.sep.presale_start_date, this.lang, true).toUpperCase()} DEL ${this.$datetime.dateFormater(this.config.sep.presale_start_date, "yyyy")}`
		// },
		// endDate() {
		//     return "TEST"
		//     // return `${this.$datetime.dateFormater(this.config.sep.presale_end_date, "dd")} DE ${this.$datetime.getMonth(this.config.sep.presale_end_date, this.lang, true).toUpperCase()} DEL ${this.$datetime.dateFormater(this.config.sep.presale_end_date, "yyyy")}`
		// },
		scheduleDeparture() {
			return (!this.reservation.departure.open) ? `${this.$datetime.getDay(this.reservation.departure.date, this.lang, true).toUpperCase()}, ${this.$datetime.dateFormater(this.reservation.departure.date, "dd")} ${this.$datetime.getMonth(this.reservation.departure.date, this.lang, true).toUpperCase()}, ${this.$datetime.dateFormater(this.reservation.departure.date, "yyyy")}` : ''
		},
		scheduleReturn() {
			return (this.reservation.round && !this.reservation.return.open) ? `- ${this.$datetime.getDay(this.reservation.return.date, this.lang, true).toUpperCase()} ${this.$datetime.dateFormater(this.reservation.return.date, "dd")} ${this.$datetime.getMonth(this.reservation.return.date, this.lang, true).toUpperCase()}, ${this.$datetime.dateFormater(this.reservation.return.date, "yyyy")}` : ''
		},

		lang: {
			set() {

			},
			get() {
				return this.get_language
			}
		},

		loading: {
			set(data) {
				this.set_loading(data)
			},
			get() {

			}
		}
	},
	methods: {
		...mapMutations({
			set_loading: _GlobalHelper.mutations.loading,
			setAlertSimple: _GlobalHelper.mutations.setAlertSimple,
			setReservation: _ReservationHelper.mutations.reservation,
			set_fechaSep: _GlobalHelper.mutations.fecha_sep,
			set_finSep: _GlobalHelper.mutations.fecha_fin_sep,
			resetStore: _ReservationHelper.mutations.resetStore,
		}),

		...mapActions({
			// Reservation
			origin: _ReservationHelper.actions.origins,
			create: _ReservationHelper.actions.create,
			promotionalCode: _ReservationHelper.actions.promotional_code
		}),


		async createReserve  () {
			this.loading_create_reservation = true
			let message = []
			let message_html = []

			let reservation = {
				origin: (this.reservation.origin != null) ? (this.$validator.hasValue(this.reservation.origin.id) && this.$validator.isInt(this.reservation.origin.id.toString(), 1)) ? this.$validator.toInt(this.reservation.origin.id.toString()) : null : null,
				destination: (this.reservation.destination != null) ? (this.$validator.hasValue(this.reservation.destination.id) && this.$validator.isInt(this.reservation.destination.id.toString(), 1)) ? this.$validator.toInt(this.reservation.destination.id.toString()) : null : null,
				round: this.reservation.round,
				redeem: false,
				departure_open: this.reservation.departure.open,
				departure_date: (this.reservation.departure.date === null) ? null : this.$datetime.dateFormater(this.reservation.departure.date, 'yyyy-mm-dd'),
				return_open: this.reservation.return.open,
				return_date: (this.reservation.return.date === null) ? null : this.$datetime.dateFormater(this.reservation.return.date, 'yyyy-mm-dd'),
				adult: this.pax.adult,
				children: this.pax.children,
				inapam: this.pax.inapam,
				infant: this.pax.infant,
				teacher: this.pax.teacher,
				teacher_flex: this.pax.teacher_flex,
				student: this.pax.student,
				student_flex: this.pax.student_flex,
				promotional_code: this.promotion.is_valid ? this.promotion.code : null
			}

			// Get Date Now
			const now_timestamp = this.$datetime.timestamp()

			if (reservation.origin === null) {
				message.push('alert.errors.empty_origin')
			}

			if (reservation.destination === null) {
				message.push('alert.errors.empty_destination')
			}

			if (this.total_passengers === 0) {
				message.push('alert.errors.empty_passengers')
			}
			if (reservation.departure_date === null && !reservation.departure_open) {
				message.push('alert.errors.empty_departure')
			}

			if (reservation.round && reservation.return_date === null && !reservation.return_open) {
				message.push('alert.errors.empty_return')
			}

			if (this.$datetime.differenceInDays(reservation.departure_date, reservation.return_date, false) > 0 && !reservation.return_open) {
				if (reservation.round) {
					message.push('alert.errors.major_equal')
				}
			}

			if (message.length > 0) {
				this.loading_create_reservation = false

				this.setAlertSimple({
					show: true,
					title: 'api.title_error',
					message: message
				})
				return
			}

			if (this.sep_date.active && (this.pax.student > 0 || this.pax.teacher > 0 )) {
				let sep_start_sale = this.$validator.toDate(this.validity.sep.sep_start_sale)
                let sep_end_sale = this.$validator.toDate(this.validity.sep.sep_end_sale)
                let sep_start_travel = this.$validator.toDate(this.validity.sep.sep_start_travel)
                let sep_end_travel = this.$validator.toDate(this.validity.sep.sep_end_travel)
                
				// Validate sale date
                let start_timestamp = this.$datetime.timestamp(sep_start_sale)
                let end_timestamp = this.$datetime.timestamp(sep_end_sale)
                
                let departure_timestamp = !this.reservation.departure.open ? this.$datetime.timestamp(this.reservation.departure.date) : null
                let return_timestamp = this.reservation.round && !this.reservation.return.open ? this.$datetime.timestamp(this.reservation.return.date) : null
                
				if (this.reservation.round) {
	                if(now_timestamp < start_timestamp || now_timestamp > end_timestamp) {
	                    message_html.push({
							message: this.sep_date,
							input: "input.sep_alert"
						})
	                }
	                // Validate travel date
	                start_timestamp = this.$datetime.timestamp(sep_start_travel)
	                end_timestamp = this.$datetime.timestamp(sep_end_travel)
					let fecha_sale = this.$datetime.dateFormater(this.reservation.return.date, 'yyyy/mm/dd')
					let fecha_sep = this.$datetime.dateFormater(sep_end_travel, 'yyyy/mm/dd')
					await this.set_fechaSep(this.$datetime.timestamp(sep_end_travel))
					await this.set_finSep(this.$datetime.timestamp(sep_start_travel))

	                if (!this.reservation.departure.open) {
		                if(departure_timestamp !== null && (departure_timestamp < start_timestamp || departure_timestamp > end_timestamp)) {
							message_html.push({
								message: this.sep_date,
								input: "input.sep_alert"
							})	
		                }
	                }
	                else {
	                	message.push('alert.errors.rate_student_open')
	                }
	                if (!this.reservation.return.open) {
		                if(return_timestamp !== null && (return_timestamp < start_timestamp || return_timestamp > end_timestamp)) {
							if (fecha_sale != fecha_sep) {
								message_html.push({
								message: this.sep_date,
								input: "input.sep_alert"
							})	
							}
		                    
		                }
		            }
	                else {
	                	message.push('alert.errors.rate_student_open')
	                }
				}
				else {
	                // Validate travel date
	                start_timestamp = this.$datetime.timestamp(sep_start_travel)
	                end_timestamp = this.$datetime.timestamp(sep_end_travel)

	                if (this.reservation.departure.date != null) {
		                if(departure_timestamp !== null && (departure_timestamp < start_timestamp || departure_timestamp > end_timestamp)) {
							message_html.push({
								message: this.sep_date,
								input: "input.sep_alert"
							})	
		                }
	                }

					if (this.reservation.departure.open) {
						message.push('alert.errors.rate_student_open')
					}

				}
			}

			if (this.sep_flex_date.active && (this.pax.student_flex > 0 || this.pax.teacher_flex > 0 )) {
				let sep_start_sale = this.$validator.toDate(this.validity.flex.sep_flex_start_sale)
                let sep_end_sale = this.$validator.toDate(this.validity.flex.sep_flex_end_sale)
                let sep_start_travel = this.$validator.toDate(this.validity.flex.sep_flex_start_travel)
                let sep_end_travel = this.$validator.toDate(this.validity.flex.sep_flex_end_travel)
                
                // Validate sale date
                let start_timestamp = this.$datetime.timestamp(sep_start_sale)
                let end_timestamp = this.$datetime.timestamp(sep_end_sale)
               
                let departure_timestamp = !this.reservation.departure.open ? this.$datetime.timestamp(this.reservation.departure.date) : null
                let return_timestamp = this.reservation.round && !this.reservation.return.open ? this.$datetime.timestamp(this.reservation.return.date) : null
               
				if (this.reservation.round) {
	                if(now_timestamp < start_timestamp || now_timestamp > end_timestamp) {
	                    message_html.push({
							message: this.sep_flex_date,
							input: "input.sep_flex_alert"
						})
	                }
	               
	                // Validate travel date
	                start_timestamp = this.$datetime.timestamp(sep_start_travel)
	                end_timestamp = this.$datetime.timestamp(sep_end_travel)
	                
	                if (!this.reservation.departure.open) {
		                if(departure_timestamp !== null && (departure_timestamp < start_timestamp || departure_timestamp > end_timestamp)) {
		                    message_html.push({
								message: this.sep_flex_date,
								input: "input.sep_flex_alert"
							})	
		                }
	                }
	                else {
	                	message.push('alert.errors.rate_student_open')
	                }
	                
	                if (!this.reservation.return.open) {
		                if(return_timestamp !== null && (return_timestamp < start_timestamp || return_timestamp > end_timestamp)) {
		                    message_html.push({
								message: this.sep_flex_date,
								input: "input.sep_flex_alert"
							})	
		                }
		            }
		            else {
	                	message.push('alert.errors.rate_student_open')
	                }
				}
				else {
	                // Validate travel date
	                start_timestamp = this.$datetime.timestamp(sep_start_travel)
	                end_timestamp = this.$datetime.timestamp(sep_end_travel)
	                
	                if (this.reservation.departure.date != null) {
		                if(departure_timestamp !== null && (departure_timestamp < start_timestamp || departure_timestamp > end_timestamp)) {
		                    message_html.push({
								message: this.sep_flex_date,
								input: "input.sep_flex_alert"
							})	
		                }
	                }

					if (this.reservation.departure.open) {
						message.push('alert.errors.rate_student_open')
					}

				}
			}
			
			if (message.length > 0) {

				this.loading_create_reservation = false

				this.setAlertSimple({
					show: true,
					title: 'api.title_error',
					message: message
				})
				return
			}

			if (message_html.length > 0) {

				this.loading_create_reservation = false
				
				this.setAlertSimple({
					show: true,
					title: 'api.title_error',
					html: {
						message: message_html[0].message,
						input: message_html[0].input
					}
				})
				return
			}

			this.loading = {
				show: true,
				message: `
                    <mu-container>
                        <h2>${this.$i18n.t(`loading.search`)}</h2>
                        <mu-row>
                            <mu-col>
                                <h5>${this.reservation.origin.label} - ${this.reservation.destination.label}</h5>
                            </mu-col>
                            <mu-col>
                                <span>${this.scheduleDeparture} ${this.scheduleReturn}</span>
                            </mu-col>
                        </mu-row>
                    </mu-container>`
			}
			
			this.resetStore()
			const save_reservation = Object.assign({} , this.reservation)

			this.create({
				reservation: reservation
			}).then(response => {

				if (!response.success && response.error === undefined) {
					this.loading_create_reservation = false
					this.loading = { show: false, message: null }
					this.setAlertSimple({
						show: true,
						title: 'api.title_error',
						message: message
					})
					this.clearReservationData()
					return
				}

				if (!response.success && response.error.length >= 0) {

					this.loading_create_reservation = false

					for (let index in response.error) {
						if (response.error[index].code === "wrong_sep_sale_date") {
							
							message_html.push({
								message: this.sep_date,
								input: "input.sep_alert"
							})
						}
						else if (response.error[index].code === "wrong_sep_travel_date") {
							
							message_html.push({
								message: this.sep_date,
								input: "input.sep_alert"
							})	
						}
						else if (response.error[index].code === "max_teacher_rate") {
							message.push('module_reservation.alert.error.max_teacher_rate')	
						}
						else if (response.error[index].code === "max_student_rate") {
							message.push('module_reservation.alert.error.max_student_rate')
						}
						else if (response.error[index].code === "sep_flex_inactive") {
							message.push('api.commons.alert.error.default_error')	
						}
						else if (response.error[index].code === "wrong_sep_flex_sale_date") {
							message_html.push({
								message: this.sep_flex_date,
								input: "input.sep_flex_alert"
							})
						}
						else if (response.error[index].code === "wrong_sep_flex_travel_date") {
							message_html.push({
								message: this.sep_flex_date,
								input: "input.sep_flex_alert"
							})
						}
						else if(response.error[index].code === "failed_log_reservation_saved") {

						}
						else {
							message.push('api.commons.alert.error.cannot_request')	
						}
					}

					if (message_html.length > 0) {
						this.loading = { show: false, message: null }
						
						this.setAlertSimple({
							show: true,
							title: 'api.title_error',
							html: {
								message: message_html[0].message,
								input: message_html[0].input
							}
						})
						this.clearReservationData()
						this.delete().then(response => { })
						return
					}

					if (message.length === 0) {
						message.push('api.commons.alert.error.default_error')
					}

					this.loading = { show: false, message: null }

					this.setAlertSimple({
						show: true,
						title: 'api.title_error',
						message: message
					})
					this.clearReservationData()
					this.delete().then(response => { })
					return
				}

				if (response.success && response.data) {

					const { created, code, configs, passengers, summary } = response.data

					if(!created) {
						this.setAlertSimple({
							show: true,
							title: 'api.title_error',
							message: ['api.commons.alert.error.cannot_request']
						})
						return
					}
					
					save_reservation.code = code
					save_reservation.configs = {...save_reservation.configs, ...configs}
					save_reservation.passengers = passengers
					save_reservation.summary = summary

					this.setReservation(save_reservation)

					if(!this.reservation.departure.open) {
						this.$router.push({ name: 'reservation-schedules' })
					}
					else {
						this.$router.push({ name: 'reservation-contact' })
					}

					this.clearReservationData()
				}
			})
			.catch(response => {
				this.loading_create_reservation = false

				for (let key in response.error) {
					this.message.push(`api.${response.error[key].code}`)
				}

				this.loading = { show: false, message: null }
				this.setAlertSimple({
					show: true,
					title: 'api.title_error',
					message: this.message
				})
				return
			})
		},

		clearReservationData() {
			// Reset Data
			Object.assign(this.$data.pax,this.$options.data.call(this).pax)
			Object.assign(this.$data.reservation,this.$options.data.call(this).reservation)
			this.total_passengers = 0
			this.$forceUpdate()
		},

		reservationRound() {
			this.reservation.round = !this.reservation.round
		},

		toggle() {
			this.display_selector = !this.display_selector
		},

		displaySelectorClose() {
			this.display_selector = false
		},

		checkboxBehavior() {
			if (this.reservation.departure.open) {
				this.reservation.return.open = true
				this.reservation.departure.date = null
			}
			if (this.reservation.return.open) {
				this.reservation.return.date = null
				this.departure_date_disable.from = null
			}

			this.setDatePickersToToday()
		},

		quantityPassengers(rate, type) {

			this.message = []
			let rate_active = false
			if (type === '-' && this.pax[rate] > 0) {
				this.pax[rate]--
				this.total_passengers--
			}
			else {

				if (type === '+' && this.total_passengers < 10) {
					// Teachers
					if (rate === 'teacher' && this.pax[rate] < 2) {
						this.pax[rate]++
						this.total_passengers++
					}
					// Students
					else if (rate === 'student' && this.pax[rate] < 4) {
						this.pax[rate]++
						this.total_passengers++
					}
					else if (['teacher', 'student'].indexOf(rate) === -1 && this.pax[rate] < 10) {
						this.pax[rate]++
						this.total_passengers++
					}
					else {
						rate_active = true
					}
				}
				else rate_active = true
			}
			if (rate_active && rate === 'student' && this.pax[rate] === 4) {
				// Solo se permiten 8 estudiantes como maximo por reserva
				this.message.push('alert.errors.students_excessses')
			}
			if (rate_active && rate === 'teacher' && this.pax[rate] === 2) {
				// Solo se permiten 2 maestros como maximo por reserva
				this.message.push('alert.errors.teachers_excessses')
			}
			if (rate_active && this.total_passengers === 10) {
				// Solo se permiten 10 pasajeros por reserva
				this.message.push('alert.errors.max_passengers')
			}

			if (this.message.length > 0) {
				this.setAlertSimple({
					show: true,
					title: 'alert.errors.passenger',
					message: this.message
				})
				return
			}


		},

		applyCode() {
			if(this.promotion.code === null) {
				this.setAlertSimple({
					show: true,
					title: 'alert.errors.promotional_code',
					message: ['No hay ingresado ningún código promocional']
				})
				return
			}

			this.promotionalCode({
				promotional_code: this.promotion.code
			}).then(response => {
				if(!response.success) {
					this.promotion.is_valid = false
					this.setAlertSimple({
						show: true,
						title: 'alert.errors.promotional_code',
						message: ['El código ingresado ya no es valido']
					})
					return
				}

				this.promotion.promotion_info = response.data.rate_season
				this.promotion.is_valid = true
			})
		},

		setDatePickersToToday() {
			let date = new Date()
			
			this.departure_date_disable.to.setDate(date.getDate() - 1)
			let month = (date.getDate() === 1) ? date.getMonth() - 1 : date.getMonth()
			
			// Departure
			this.departure_date_disable.to.setMonth(month)
			this.departure_date_disable.to.setFullYear(date.getFullYear() - (date.getMonth() == 0 && date.getDate() == 1 ? 1 : 0))
			this.departure_date_disable.from = null

			// Return
			this.return_date_disable.to.setDate(date.getDate())
			this.return_date_disable.to.setMonth(date.getMonth())
			this.return_date_disable.to.setFullYear(date.getFullYear())
		},

		selectionDate(type) {
			let date = new Date()

			switch (type) {
				case 'departure':
					date = new Date(this.reservation.departure.date)
					this.return_date_disable.to = new Date(date.getFullYear(), date.getMonth(), date.getDate())
					break

				case 'return':
					date = new Date(this.reservation.return.date)
					this.departure_date_disable.from = new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1)
					break
			}
		},

		getOrigin() {
			this.message = []

			this.origin().then(response => {

				if (!response.success) {
					if (this.message.length === 0) {
						this.message.push('api.commons.alert.error.default_error')
					}
					this.loading = { show: false, message: null }

					this.setAlertSimple({
						show: true,
						title: 'api.title_error',
						message: this.message
					})
					return
				}

				if (response.success && response.data != undefined) {

					for (let org in response.data.origins) {
						this.origins.push({
							id: response.data.origins[org].id,
							label: response.data.origins[org].name,
							tag: response.data.origins[org].tag,
							ref: parseInt(org)
						})

						this.destinations.push(response.data.origins[org].destinations)

					}

					for (let key in this.destinations) {
						for (let des in this.destinations[key]) {
							this.destinations[key][des] = {
								id: this.destinations[key][des].id,
								label: this.destinations[key][des].name,
								tag: this.destinations[key][des].tag,
							}
						}
					}

					let sale_start_date = null
					let sale_end_date = null

					//Set Configs Sep
					this.reservation.configs = {
						sep_config: response.data.configs
					}

					for(let i in response.data.configs) {
						const res = response.data.configs[i]

						if(res.key === 'default_point_traveller') {
							this.default_point = parseInt(res.value) ? true : false
						}

						if(res.key === 'show_promotional_code') {
							this.config.promotional_code = res.value == '1' ? true : false
						}

						if(res.key === 'sep_active') {
							this.sep_date.active = res.value == 1 ? true : false
						}

						if(res.key === 'sep_start_travel') {
							this.validity.sep['sep_start_travel'] = res.value.replace(/-/g, '/')
							const sale_start_date = res.value.replace(/-/g, '/')
							this.sep_date.sep_start_travel = `${this.$datetime.dateFormater(sale_start_date, "dd")} DE ${this.$datetime.getMonth(sale_start_date, this.lang, true).toUpperCase()} DEL ${this.$datetime.dateFormater(sale_start_date, "yyyy")}`
						}
						
						if(res.key === 'sep_end_travel') {
							this.validity.sep['sep_end_travel'] = res.value.replace(/-/g, '/')
							const sale_end_date = res.value.replace(/-/g, '/')	
							this.sep_date.sep_end_travel = `${this.$datetime.dateFormater(sale_end_date, "dd")} DE ${this.$datetime.getMonth(sale_end_date, this.lang, true).toUpperCase()} DEL ${this.$datetime.dateFormater(sale_end_date, "yyyy")}`
						}
						
						if(res.key === 'sep_start_sale') {
							this.validity.sep['sep_start_sale'] = res.value.replace(/-/g, '/')
							const sale_start_date = res.value.replace(/-/g, '/')
							this.sep_date.sep_start_sale = `${this.$datetime.dateFormater(sale_start_date, "dd")} DE ${this.$datetime.getMonth(sale_start_date, this.lang, true).toUpperCase()} DEL ${this.$datetime.dateFormater(sale_start_date, "yyyy")}`
						}
						if(res.key === 'sep_end_sale') {
							this.validity.sep['sep_end_sale'] = res.value.replace(/-/g, '/')
							const sale_end_date = res.value.replace(/-/g, '/')	
							this.sep_date.sep_end_sale = `${this.$datetime.dateFormater(sale_end_date, "dd")} DE ${this.$datetime.getMonth(sale_end_date, this.lang, true).toUpperCase()} DEL ${this.$datetime.dateFormater(sale_end_date, "yyyy")}`
						}

						if(res.key === 'sep_flex_active') {
							this.sep_flex_date.active = res.value == 1 ? true : false
						}

						if(res.key === 'sep_flex_start_travel') {
							this.validity.flex['sep_flex_start_travel'] = res.value.replace(/-/g, '/')
							const sale_start_date = res.value.replace(/-/g, '/')
							this.sep_flex_date.sep_flex_start_travel = `${this.$datetime.dateFormater(sale_start_date, "dd")} DE ${this.$datetime.getMonth(sale_start_date, this.lang, true).toUpperCase()} DEL ${this.$datetime.dateFormater(sale_start_date, "yyyy")}`
						}
						
						if(res.key === 'sep_flex_end_travel') {
							this.validity.flex['sep_flex_end_travel'] = res.value.replace(/-/g, '/')
							const sale_end_date = res.value.replace(/-/g, '/')	
							this.sep_flex_date.sep_flex_end_travel = `${this.$datetime.dateFormater(sale_end_date, "dd")} DE ${this.$datetime.getMonth(sale_end_date, this.lang, true).toUpperCase()} DEL ${this.$datetime.dateFormater(sale_end_date, "yyyy")}`
						}
						
						if(res.key === 'sep_flex_start_sale') {
							this.validity.flex['sep_flex_start_sale'] = res.value.replace(/-/g, '/')
							const sale_start_date = res.value.replace(/-/g, '/')
							this.sep_flex_date.sep_flex_start_sale = `${this.$datetime.dateFormater(sale_start_date, "dd")} DE ${this.$datetime.getMonth(sale_start_date, this.lang, true).toUpperCase()} DEL ${this.$datetime.dateFormater(sale_start_date, "yyyy")}`
						}
						if(res.key === 'sep_flex_end_sale') {
							this.validity.flex['sep_flex_end_sale'] = res.value.replace(/-/g, '/')
							const sale_end_date = res.value.replace(/-/g, '/')	
							this.sep_flex_date.sep_flex_end_sale = `${this.$datetime.dateFormater(sale_end_date, "dd")} DE ${this.$datetime.getMonth(sale_end_date, this.lang, true).toUpperCase()} DEL ${this.$datetime.dateFormater(sale_end_date, "yyyy")}`
						}
					}

					this.loading_origins = false
					return
				}
			})
			.finally(() => {
				this.loading_origins = false
			})
		},

	},
	created() {
		// Set Picket
		this.setDatePickersToToday()
		// Get Origins
		this.getOrigin()

		//Send Tag One Signal
		if(process.env.APP_ENV === 'prod') {
			this.$watch('reservation.origin', async (data) => {
				await this.$push.sendTag('origin', data)
			})
		}
	},
	destroyed() {
		this.clearReservationData()
	}
}
</script>


<style lang="scss">
	.sep-font {
		font-size: 0.7em;
	}

	/*lang='scss' scoped*/
	/* Custom styles for DatePicker component */
	.DatePicker input {
		background-color: white !important;
		width: 100%;
		height: 38px;
		color: #706f6f;
		font-size: 16px;
	}
	
	.RowContainer {
		display: flex;
		flex-direction: row;
		align-items: center;
	}
	.CheckboxContainer {
		padding: 0px 10px 0px 0px;
		display: flex;
		flex-direction: row;
		align-items: center;
		text-align: center;
	}
	.CheckboxContainer label {
		padding: 8px 5px 0px 0px;
		font-size: 1em;
		color: #706f6f;
	}
	/* Styles for Passenger */
	.PassengersSelector {
		background-color: white;
		border: 1px solid #ced4da;
		border-radius: 0.25rem;
		line-height: 1.5;
		z-index: 2;
		width: 100%;
		height: 38px;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		color: #706f6f;
		position: relative;
		padding-right: 0px;
	}
	.SelectorContainer {
		background-color: #fff;
		border: 1px solid #ced4da;
		border-radius: 0.25rem;
		z-index: 100;
		margin-top: 0px;
		position: absolute;
		top: 38px;
		left: 8px;
		width: 100%;
		min-width: 300px;
	}
	.SelectorContainer .PassengersSelectorContent {
		color: #706f6f;
		list-style: none;
		padding: 4px 10px 4px 10px;
		margin: 0px;
	}

	.SelectorContainer .PassengersSelectorItem {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		padding: 4px;
		border-bottom: 2px solid #c8c8c8;
	}

	.SelectorContainer .PassengersSelectorButton {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
		padding: 5px;
	}
	.SelectorButton button {
		background-color: #005296;
		border-color: #0275d8;
		padding: 8px 16px 8px 16px;
	}

	.SelectorContainer .PassengersSelectorOperators {
		width: 55px;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
	}

	.mu-tooltip {
		position: fixed;
		font-size: 12px;
		line-height: 22px;
		padding: 4px 8px;
		color: #fff;
		border-radius: 15px;
		background-color: #fff;
		opacity: 1.0;
		left: 300px;
		top: 400px;
	}
	.btnInfopromotionalCode {
		width: fit-content;
		height: fit-content;
		padding: 0;
	}

	.promotionalInfoText{
		color: #706f6f;
		margin: 0
	}
	.promotionalInfoTitle{
		color: #005296;
		font-size: 13px;
		font-weight: bold;
		margin-bottom: 0.5em;
	}

	.vs-notification{
		padding: 0px !important;
	}
</style>
